import { render } from "./SystemSettings.vue?vue&type=template&id=41537bec&scoped=true"
import script from "./SystemSettings.vue?vue&type=script&lang=js"
export * from "./SystemSettings.vue?vue&type=script&lang=js"

import "./SystemSettings.vue?vue&type=style&index=0&id=41537bec&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41537bec"]])

export default __exports__